import pages from "../../../data/pages.json";

export interface PageData {
  id: string;
  title: string;
  route: string;
  url: string;
  menus?: string[];
  description?: string;
}

export interface MenuItem {
  title: string;
  route: string;
  url: string;
}

/**
 * Returns every pages' data (title, description, url, etc.)
 */
export function getAllPageData(): PageData[] {
  return [...pages];
}

/**
 * Returns the given page's data (title, description, url, etc.)
 */
export function getPageData(pageId: string): PageData {
  const page = pages.find((page) => page.id === pageId);

  if (!page) {
    throw new Error(`${pageId} is invalid page id`);
  }

  return page;
}

/**
 * Returns the given page's data (title, description, url, etc.)
 */
export function getPageDataByRoute(route: string): PageData | null {
  return pages.find((page) => page.route === route) || null;
}

/**
 * Returns the menu items of the given menu
 */
export function getMenuItems(menu: string): MenuItem[] {
  const items: MenuItem[] = [];

  for (const page of pages) {
    if (page.menus?.includes(menu)) {
      items.push({
        title: page.title,
        route: page.route,
        url: page.url,
      });
    }
  }

  return items;
}

export function getUrlOfPage(pageId: string) {
  const page = pages.find((page) => page.id === pageId);

  return page ? page.url : "#";
}

export function getUrlFromRoute(route: string) {
  const page = pages.find((page) => page.route === route);

  return page ? page.url : "/";
}
